import Vue from 'vue';
import { ModalPlugin } from 'bootstrap-vue';
import VueCompositionAPI from '@vue/composition-api';

import VueGtag from 'vue-gtag';
import VueTimeago from 'vue-timeago';
import VueShortKey from 'vue-shortkey';
import VueMeta from 'vue-meta';

import router from './router';
import store from './store';
import App from './App.vue';

// Global Components
import './global-components';

// 3rd party plugins
import '@axios';
import '@/libs/acl';
import '@/libs/portal-vue';
import '@/libs/clipboard';
import '@/libs/flag';
import '@/libs/toastification';
import '@/libs/sweet-alerts';
import '@/libs/vue-select';
import '@/libs/tour';

import './registerServiceWorker';

// BSV Plugin Registration
Vue.use(ModalPlugin);

Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'en', // Default locale
  autoUpdate: 60,
});

Vue.use(VueShortKey);

// Composition API
Vue.use(VueCompositionAPI);

// Satoshi
require('@core/assets/fonts/inter/font.css');

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css'); // For form-wizard

// import core styles
require('@core/scss/core.scss');

// import assets styles
require('@/assets/scss/style.scss');

require('leaflet/dist/leaflet.css');

Vue.config.productionTip = false;

Vue.use(
  VueGtag,
  {
    config: { id: 'G-QS1VFPJ0MV' },
    appName: 'Mgmt Portal',
    pageTrackerScreenviewEnabled: true,
  },
  router,
);

Vue.use(VueMeta);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
